import dynamic from 'next/dynamic'
import { StrapiV4Image } from '../image/image'
import { TStrapiV4Multimedia } from '../../common-types'

const StrapiV4Lottie = dynamic(() => import('../lottie/lottie'))

const StrapiV4Video = dynamic(() => import('../video/video'))

const StrapiV4Multimedia = ({
  data,
  videoWrapperClasss = '',
}: {
  data?: TStrapiV4Multimedia
  videoWrapperClasss?: string
}) => {
  return (
    <>
      {data?.img && (
        <StrapiV4Image
          alt={data.img.alt}
          img={data.img.img_url}
          width={data.img.width}
          height={data.img.height}
          priority={data.img.priority}
          verticalBuffer={data.img.vertical_buffer ?? true}
        />
      )}

      {data?.lottie && (
        <StrapiV4Lottie
          lottieUrl={data.lottie.lottie_json_url}
          width={data.lottie.width}
          height={data.lottie.height}
          className="!my-0"
        />
      )}

      {data?.video && (
        <StrapiV4Video
          data={data.video}
          videoWrapperClasss={videoWrapperClasss}
        />
      )}
    </>
  )
}

export default StrapiV4Multimedia
